const USER_RECORD_REQUEST = {
    // baseUrl: "https://etextbook.knsh.com.tw/"
    baseUrl: "https://knshebook2.knsh.com.tw/WebApiTest/"
    // baseUrl: "http://localhost:7397/"
}

export const USER_RECORD_BUCKET = "https://storage.googleapis.com/ebookcloudsave/";

/**
 * 查詢使用者記錄
 * @param {string} book_id 
 * @param {string} user_id 
 * @returns {Promise<Response>}
 */
export const getUserRecord = (book_id, user_id) => {
    const action = "api/Sync/GetEbookRecord";
    return fetch(`${USER_RECORD_REQUEST.baseUrl}${action}?uid=${user_id}&book_id=${book_id}`)
}
/**
 * 上傳使用者記錄
 * @param {{log_name:string, book_id:string, user_id:string, data:string}} item 
 * @returns {Promise<Response>}
 */
export const postAddUserRecord = (item) => {
    const action = "api/Sync/AddUserRecord";
    return fetch(`${USER_RECORD_REQUEST.baseUrl}${action}`,
        {
            method: "POST",
            body: JSON.stringify(item),
            headers: {
                'content-type': 'application/json'
            }
        }
    )
}
/**
 * 更新使用者記錄
 * @param {{log_name:string, book_id:string, user_id:string, data:string}} item  
 * @returns {Promise<Response>}
 */
export const postUpdateUserRecord = (item) => {
    console.log("post body:", JSON.stringify(item))
    const action = "api/Sync/UpdateUserRecord";
    return fetch(`${USER_RECORD_REQUEST.baseUrl}${action}`,
        {
            method: "POST",
            body: JSON.stringify(item),
            headers: {
                'content-type': 'application/json'
            }
        }
    )
}

export const postDeleteUserRecord = (item) => {
    const action = "api/Sync/deleteUserRecord";
    return fetch(`${USER_RECORD_REQUEST.baseUrl}${action}`,
        {
            method: "POST",
            body: JSON.stringify(item),
            headers: {
                'content-type': 'application/json'
            }
        }
    )
}
/**
 * 上傳紀錄使用的圖片
 * @param {{log_name: string, book_id:string, user_id: string, image_name: string, bytes: byte[]}} item 
 * @returns 
 */
export const uploadRecordImage = (item) => {
    const action = "api/Sync/UploadRecordImage";
    return fetch(`${USER_RECORD_REQUEST.baseUrl}${action}`,
        {
            method: "POST",
            body: item,
            headers: {
                'content-type': 'application/json'
            }
        }
    )
}